<loading [loading]="loading.is_display" [loadingMessage]="loading.message"></loading>

<ng-container *ngIf="!loading.is_display">
  <ng-container *ngIf="error_message">
    <div class="alert alert-danger">
      <button type="button" class="close" data-dismiss="alert" (click)="clearErrors(error_message)">×</button>
      {{ error_message }}
    </div>
  </ng-container>

  <section
    role="dialog"
    tabindex="-1"
    aria-labelledby="modal-heading-01"
    aria-modal="true"
    class="slds-modal_large settings-list"
  >
    <div class="slds-modal__container">
      <div class="slds-modal__content slds-p-around_medium">
        <div class="slds-page-header">
          <h1>
            <span class="slds-page-header__title slds-truncate header-style">
              Document Flow
              <div *ngIf="isUserHasAccess" class="slds-float_right">
                <a
                  class="btn btn-primary"
                  routerLink="template_settings_form"
                  routerLinkActive="active"
                  (click)="routeToCreateForm()"
                >
                  Create new
                </a>
              </div>
            </span>
          </h1>
        </div>
      </div>
      <div *ngIf="!isUserHasAccess" class="slds-truncate wrong-access-profile">
        This section requires an administrator profile. Contact your organization administrator to set
        Document Flow.
      </div>
      <div *ngIf="isUserHasAccess" class="text-center">
        <!-- items being paged -->
        <table class="slds-table slds-table_cell-buffer slds-table_bordered">
          <tbody>
            <tr class="slds-hint-parent" *ngFor="let item of pagedItems; let i = index">
              <td data-label="Opportunity Name" scope="row">
                <div class="slds-truncate">
                  {{ item.setting_name }}
                </div>
              </td>
              <td data-label="Options" class="buttons-section list-width">
                <button type="button" title="Edit" class="btn btn-primary" (click)="onEdit(i, item)">
                  Edit
                </button>
                <button type="button" title="Delete" class="btn btn-primary" (click)="openModal(item)">
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- pager -->
        <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
          <li [ngClass]="{ disabled: pager.currentPage === 1 }">
            <a (click)="setPage(1)">First</a>
          </li>
          <li [ngClass]="{ disabled: pager.currentPage === 1 }">
            <a (click)="setPage(pager.currentPage - 1)">Previous</a>
          </li>
          <li *ngFor="let page of pager.pages" [ngClass]="{ active: pager.currentPage === page }">
            <a (click)="setPage(page)">{{ page }}</a>
          </li>
          <li [ngClass]="{ disabled: pager.currentPage === pager.totalPages }">
            <a (click)="setPage(pager.currentPage + 1)">Next</a>
          </li>
          <li [ngClass]="{ disabled: pager.currentPage === pager.totalPages }">
            <a (click)="setPage(pager.totalPages)">Last</a>
          </li>
        </ul>
      </div>
    </div>
  </section>

  <ng-container *ngIf="is_delete_settings">
    <div class="slds-modal-wrap">
      <div tabindex="-1" class="slds-modal slds-fade-in-open shadow-none">
        <div class="slds-modal__container shadow-none">
          <header class="slds-modal__header">
            <h2 class="slds-text-heading_medium slds-hyphenate">Deleting Flow Settings</h2>
          </header>
          <div class="slds-modal__content slds-p-around_medium">
            Are you sure you want to delete <b>{{ selectedItem.setting_name }}</b> settings?
          </div>
          <footer class="slds-modal__footer">
            <button class="btn btn-neutral" (click)="closeModal()">Cancel</button>
            <button class="btn btn-primary" (click)="deleteTemplate()">Delete</button>
          </footer>
        </div>
      </div>
      <div class="slds-backdrop slds-backdrop_open"></div>
    </div>
  </ng-container>
</ng-container>
